import EA from 'helpers/init';
import Swiper from 'swiper';
import 'swiper/css';

export default EA.Methods.gridSlider = ($this) => {
    const slider = $this.querySelector('.swiper');
    const mq = window.matchMedia('(min-width: 1001px)');
    let mySwiper;

    const enableSwiper = function() {
        mySwiper = new Swiper(slider, {
            speed: 600,
            slidesPerView: 1,
            spaceBetween: 12,
            allowTouchMove: true,
            breakpoints: {
                481: {
                    slidesPerView: 1.3,
                    spaceBetween: 20,
                },
                601: {
                    slidesPerView: 1.9,
                    spaceBetween: 20,
                },
                801: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                }
            }
        });
    };

    const breakpointChecker = function() {
        if ( mq.matches === false ) {
            return enableSwiper();
        } else if ( mq.matches === true ) {
            if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
            return;
        }
    };

    mq.addEventListener('change', breakpointChecker);
    breakpointChecker();
};
